module.exports = __webpack_public_path__ + "static/img/tuandui.f3c8cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/tuandui.png
// module id = 5XMI
// module chunks = 70